module.exports = __webpack_public_path__ + "img/ROS_Logo_White.a2760905.svg";